<template>
   <v-app>
    <v-content>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'ResetPassword',
  data() {
    return {
    }
  },
  mounted: function() {
    this.verify()
  },
  methods: {
    async verify() {
      try {
        const url = 'api/v1/auth/verifyEmail/' + this.$route.query.key + '/' + this.$route.query.token + '?expires=' + this.$route.query.expires + '&signature=' + this.$route.query.signature

        const response = await axios.get(url)
      
        this.setLoginAlert({ show: true, type: "success", icon: "check_circle", message: response.data.message });  
        this.$router.push('/login')
      } catch (error) {
        this.setLoginAlert({ show: true, type: "error", icon: "error", message: error.response.data.message });
        this.$router.push('/login')
      }
    },
    ...mapActions([
      'setLoginAlert'
    ])
  }
}
</script>